import React, {useState} from 'react';
import { connect } from 'react-redux';
import { setLoteria } from '../../../../actions'
import { getLoteria } from '../../../../services/Loterias';
import { alerta } from '../../../../services/utilities';

function Tabla(props){

    const lista_loterias = props.tableLoterias.data;
    const [filter, setFilter] = useState('');
    const estilosDias = {
        LUNES: 'badge rounded-pill text-bg-dark m-1',
        MARTES: 'badge rounded-pill text-bg-info m-1',
        MIERCOLES: 'badge rounded-pill text-bg-warning m-1',
        JUEVES: 'badge rounded-pill text-bg-danger m-1',
        VIERNES: 'badge rounded-pill text-bg-success m-1',
        SABADO: 'badge rounded-pill text-bg-secondary m-1',
        DOMINGO: 'badge rounded-pill text-bg-primary m-1',
      };

    const filteredData = Array.isArray(lista_loterias) ? lista_loterias.filter((item) => {
        const filterValue = filter.toLowerCase();
        const idMatch = item.id_loteria?.toString().includes(filter);
        const loteriaMatch = item.prefijo?.toLowerCase().includes(filterValue);
        const cantidadSorteosMatch = (item.cantidad_sorteos ?? '').toString().includes(filter);
        const estadoTexto = item.estado_id == '1' ? 'activa' : 'inactiva';
        const estadoMatch = estadoTexto.includes(filterValue);
        const horarioMatch = Array.isArray(item.horario) && item.horario.some((horario) => horario.nombre_dia?.toLowerCase().includes(filterValue));

        return idMatch || loteriaMatch || cantidadSorteosMatch || estadoMatch || horarioMatch;
    }) : [];

    const handleLoteriaSeleccionada = (id_loteria) => {

        getLoteria(id_loteria).then(response => {
            if(response.status === 200){
                props.setLoteria(response.data.data[0]);
            }else{
                alerta('Error al cargar la loteria, intente nuevamente');
            }
        })
    }
    
    return(
        <React.Fragment>
            <div className="row align-items-end">
                <div className='col-md-5 pt-2 pb-3'>
                    <div className="input-group">
                        <span className="input-group-text" id="basic-addon1"><i className="bi bi-search"></i></span>
                        <input type="text" className="form-control form-control-sm" placeholder="Buscar..." aria-label="Buscar" aria-describedby="basic-addon1" value={filter}
                        onChange={(e) => setFilter(e.target.value)} />
                    </div>
                </div>
                {parseInt(props.rol_id) === 0 ?
                <div className="col-md-7 pt-2 pb-3">
                    <div style={{ textAlign : 'right' }}>
                        <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalNuevaLoteria">Crear una nueva loteria</button>
                    </div>
                </div>
                : ''}
            </div>
            <table className="table table-hover table-sm">
                <thead>
                    <tr>
                    <th className="text-left">Id</th>
                        <th className="text-left">Loteria</th>
                        <th className="text-center">Cantidad sorteos</th>
                        <th className="text-left">Dias</th>
                        <th className="text-center">Estado</th>
                        <th  className="text-center">Ver</th>
                    </tr>
                </thead>
                <tbody>
                {filteredData.map((loteria, index) => (
                    <tr key={index}>
                        <td className="text-left">{loteria.id_loteria}</td>
                        <td className="text-left">{loteria.prefijo}</td>
                        <td className="text-center">{loteria.cantidad_sorteos ?? 0}</td>
                        <td className="text-left">
                        {loteria.horario.map((horario, index) => (
                            <span className={estilosDias[horario.nombre_dia]} key={index}>
                                {horario.nombre_dia.toLowerCase()}
                            </span>
                        ))}
                        </td>
                        <td className="text-center">
                            {loteria.estado_id == '1' ?<p className='text-success'>activa</p> : <p className='text-danger'>inactiva</p>}
                        </td>
                        <td className="text-center">
                            <button 
                                type="button" 
                                className="btn btn-outline-primary btn-sm " 
                                title="Ver Loteria" 
                                data-bs-toggle="modal" 
                                data-bs-target="#modalEditarLoteria"
                                onClick={() => handleLoteriaSeleccionada(loteria.id_loteria)}
                                >
                                <i className="bi bi-gear"></i>
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </React.Fragment>
    );
}

const mapSateToProps = state => {

    return {
        tableLoterias: state.tableLoterias
    }
}

const mapDispatchToProps  = {
    setLoteria
};

export default  connect(mapSateToProps, mapDispatchToProps)(Tabla);
